const preference = [
  { label: "Both", value: "1" },
  { label: "Exercises", value: "2" },
  { label: "Sports", value: "3" },
];

export default preference;